import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox, DBDropDown, DBIntRangeField, DBTextArea } from '_components';
import styles from './Common.module.css'
import { PatientCareCenterNotePlanHrs } from 'PatientCareCenter/Note/WorkProgram/Plan'
import { getPocTextLong } from '_helpers';

class PatientCareCenterNotePlanBody extends React.Component {

    constructor(props) {
        super(props);
        this.pnPocClicked = this.pnPocClicked.bind(this);
    }

    componentDidMount() {
        if (this.props.requireNewPoc && !this.props.plan.PLNEWPOC) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLNEWPOC', true);
        }
    }


    pnPocClicked(field, val) {
        if (field === 'new' && val === true && this.props.plan.PLCONTINUE) {
            this.props.clearField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLCONTINUE');
        }
        else if (field === 'continue' && val === true &&
            (this.props.plan.PLNEWPOC ||
                this.props.plan.PLPOCTIMESMIN ||
                this.props.plan.PLPOCTIMESMAX ||
                this.props.plan.PLPOCTIMETYPE ||
                this.props.plan.PLPOCDURMIN ||
                this.props.plan.PLPOCDURMAX ||
                this.props.plan.PLPOCDURTYPE ||
                this.props.plan.PLPOCDETAILS)) {

            let fields = ['PLNEWPOC',
                'PLPOCTIMESMIN',
                'PLPOCTIMESMAX',
                'PLPOCTIMETYPE',
                'PLPOCDURMIN',
                'PLPOCDURMAX',
                'PLPOCDURTYPE',
                'PLPOCDETAILS'
            ];
            this.props.clearFields(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, fields);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <span className={styles.label}>Projected Discharge Date:</span>
                    <span className={styles.plan_disChargeDate}>{this.props.hrs && this.props.disChargeDate}</span>
                </div>


                <div className={styles.row}>
                    <span className={styles.label}>Attended/Timed CPT Codes</span>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWP97545'
                        className={styles.plan_checkbox}
                        label='Work Conditioning/Work Hardening: 97545'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWP97546'
                        className={styles.plan_checkbox}
                        label='Work Conditioning/Work Hardening: 97546'
                    />
                </div>

                {this.props.rtmAvailable &&
                    <div className={styles.row}>
                        <span className={styles.label} />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={this.props.plno}
                            field='PLRTM'
                            className={styles.plan_checkbox}
                            label='Remote Therapeutic Monitoring'
                        />
                    </div>
                }

                {this.props.isWc &&
                    <span>
                        <div className={styles.row}>
                            <span className={styles.label}>Work Comp Codes</span>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLFCE'
                                className={styles.plan_checkbox}
                                label='FCE to determine safe RTW status at end of POC'
                            />
                        </div>
                    </span>
                }
                <div className={styles.padding_row} />
                {patientAppearance({ ...this.props, pnPocClicked: this.pnPocClicked })}

                {(this.props.noteType === 2 || this.props.noteType === 3 || this.props.noteType === 5) &&
                    <span>
                        {!this.props.requireNewPoc &&
                            <div className={styles.row}>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTPLAN'
                                    entityKeyColumn='PLNO'
                                    entityKeyValue={this.props.plno}
                                    field='PLCONTINUE'
                                    className={styles.new_poc}
                                    label='Continue with recommended plan of care.'
                                    onClick={(val) => this.pnPocClicked('continue', val)}
                                />
                                <label className={styles.poc_label}>{getPocTextLong(this.props.poc)}</label>
                            </div>
                        }
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTPLAN'
                                entityKeyColumn='PLNO'
                                entityKeyValue={this.props.plno}
                                field='PLFOLLOWUP'
                                className={styles.new_poc}
                                label='Follow up with physician.'
                            />
                        </div>
                    </span>
                }

            </div>
        );

        function patientAppearance(props) {
            return (<><div className={styles.row_not_full}>
                {(props.noteType === 2 || props.noteType === 3 || props.noteType === 5) &&
                    <DBCheckBox
                        noteId={props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={props.plno}
                        field='PLNEWPOC'
                        disabled={props.requireNewPoc}
                        className={props.requireNewPoc ? styles.new_poc_req : styles.new_poc}
                        label='Patient will be seen for'
                        onClick={(val) => props.pnPocClicked('new', val)} />}
                <DBIntRangeField
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    min={1}
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    fieldLower='PLPOCTIMESMIN'
                    fieldUpper='PLPOCTIMESMAX'
                    className={styles.poc_input} />
                <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}>time(s) per week for</label>
                <DBIntRangeField
                    noteId={props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={props.plno}
                    min={1}
                    disabled={props.plan.PLEVALONLY || (props.noteType !== 1 && !props.plan.PLNEWPOC)}
                    fieldLower='PLPOCDURMIN'
                    fieldUpper='PLPOCDURMAX'
                    className={styles.poc_input} />
                <label className={props.noteType === 1 || props.requireNewPoc ? styles.sentence_req : styles.sentence}> weeks.</label>

            </div>
                <br />
                {props.rangeUsed &&
                    <div className={styles.row}>
                        <label className={styles.details}>Details:</label>
                        <DBTextArea
                            noteId={props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={props.plno}
                            field='PLPOCDETAILS'
                            className={styles.textarea}
                        />
                    </div>
                }
                {props.hrs && props.plan.PLNEWPOC && (<><br /><PatientCareCenterNotePlanHrs customOptions={props.customOption} /></>)}
            </>

            )
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let plan = state.entities.notes.PTPLAN[plno];
    let timedModalities = Object.keys(state.entities.notes.PTPLANTIMEDMODALITIES)
        .filter(key => state.entities.notes.PTPLANTIMEDMODALITIES[key].TMPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANTIMEDMODALITIES[a].TMNO - state.entities.notes.PTPLANTIMEDMODALITIES[b].TMNO)
        .map(key => state.entities.notes.PTPLANTIMEDMODALITIES[key]);
    let untimedModalities = Object.keys(state.entities.notes.PTPLANUNTIMEDMODALITIES)
        .filter(key => state.entities.notes.PTPLANUNTIMEDMODALITIES[key].UMPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANUNTIMEDMODALITIES[a].UMNO - state.entities.notes.PTPLANUNTIMEDMODALITIES[b].UMNO)
        .map(key => state.entities.notes.PTPLANUNTIMEDMODALITIES[key]);
    let untimedOther = Object.keys(state.entities.notes.PTPLANUNTIMEDOTHER)
        .filter(key => state.entities.notes.PTPLANUNTIMEDOTHER[key].UOPLNO === plno)
        .sort((a, b) => state.entities.notes.PTPLANUNTIMEDOTHER[a].UONO - state.entities.notes.PTPLANUNTIMEDOTHER[b].UONO)
        .map(key => state.entities.notes.PTPLANUNTIMEDOTHER[key]);
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let pocKey = Object.keys(state.entities.pocs)
        .find(key => state.entities.pocs[key].epno === epno &&
            new Date(state.entities.pocs[key].startDate).getTime() <= today.getTime() &&
            new Date(state.entities.pocs[key].endDate).getTime() >= today.getTime());

    let poc = undefined;

    if (pocKey !== undefined) {
        poc = state.entities.pocs[pocKey];
    } else {
        let pocs = Object.keys(state.entities.pocs)
            .filter(key => state.entities.pocs[key].epno === epno &&
                new Date(state.entities.pocs[key].endDate).getTime() < today.getTime())
            .sort((a, b) => new Date(state.entities.pocs[b].startDate).getTime() - new Date(state.entities.pocs[a].startDate).getTime())
            .map(key => state.entities.pocs[key]);
        if (pocs.length > 0) {
            poc = pocs[0];
        }
    }

    let requireNewPoc = poc === undefined || poc.status === 3 ? true : false;

    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let rangeUsed = plan.PLPOCTIMESMIN || plan.PLPOCDURMIN ? true : false;

    let rtmAvailable = state.entities.admissions[epno].rtm98975Billable ||
        state.entities.admissions[epno].rtm98977Billable ||
        state.entities.admissions[epno].rtm98980Billable ||
        state.entities.admissions[epno].rtm98981Billable ||
        state.entities.admissions[epno].rtm98985Billable ||
        state.entities.admissions[epno].rtm98979Billable;


    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = false;
    }

    let isMinEnabled = state.entities.masterData.props ? state.entities.masterData.PROPS['PEDS_MIN_PER_SESSION_ENABLED'].PRVALUE === 'true' : false;

    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;

    let speechSelectedOptions = Object.keys(state.entities.notes.MLSPEECH)
        .filter(key => {
            return (state.entities.notes.MLSPEECH[key].XLSPXLNO === xlno)
        })
        .sort((a, b) => state.entities.notes.MLSPEECH[a].XLSPNO - state.entities.notes.MLSPEECH[b].XLSPNO)
        .map(key => state.entities.notes.MLSPEECH[key].XLSPSPNO);

    let isWp = state.entities.admissions[epno].isWP;
    const daysToAdd = parseInt(plan.PLPOCDURMAX) * 7;
    const currentDate = new Date();
    const resultDate = new Date(currentDate);
    resultDate.setDate(currentDate.getDate() + daysToAdd);
    let hrs = plan['PLPOCDURMAX'];

    return {
        noteId,
        noteType,
        isWc: state.entities.admissions[epno].isWc,
        plno,
        plan,
        poc,
        timedModalities,
        untimedModalities,
        untimedOther,
        rangeUsed,
        requireNewPoc,
        rtmAvailable,
        isPeds,
        isSpeech,
        speechSelectedOptions,
        isMinEnabled,
        isWp,
        disChargeDate: resultDate?.toDateString(),
        hrs,
    };
}

const connectedPatientCareCenterNotePlanBody = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNotePlanBody);
export { connectedPatientCareCenterNotePlanBody as PatientCareCenterNotePlanBody };

